<template>
        <div>
            <h3 v-if="!this.isAddEquipmentMode" class="editor-header px-2">
                {{ $t('stair.editor_title')  }}
            </h3>
            <location-deviation v-if="!this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div class="row" v-if="!this.isAddEquipmentMode">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-sm-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('stair.railing_type') }}</span>
                        <select
                            v-model="item.railing_type"
                            class="form-control form-control-sm"
                        >
                            <option
                                v-for="item in getStairRailings()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('portal.code') }}</span>
                        <input
                            id="height"
                            v-model="item.code"
                            type="text"
                            class="form-control form-control-sm"
                            min="1"
                        />
                    </div>

                    <div class="col-sm-4">
                        <condition-selector v-model="item.condition" :required="true"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('railing.material') }}</span>
                        <select
                            v-model="item.material"
                            class="form-control form-control-sm"
                            :class="{ 'is-invalid': !item.material }"
                        >
                            <option
                                :value="null"
                                disabled
                            >
                                {{ $t('railing.select_material') }}
                            </option>
                            <option
                                v-for="item in getMaterials()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-4">
                        <location-deviation :editMode="true" :location-deviation="item.location_deviation" @updateLocationDeviation="updateLocationDeviation"/>
                    </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-12">
                        <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                        <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :roadInfo="item"
                            :locationSpecification="item.location_specification"
                            :tracksRequired="this.sideRequired(item.location_deviation)"
                            :hideTracksSelector="!this.sideRequired(item.location_deviation)"
                            :sideRequired="this.sideRequired(item.location_deviation)"
                            :hideSideSelector="!this.sideRequired(item.location_deviation)"
                        />
                    </div>
                </div>
                <hr class="mb-0">
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <velho-equipment-damages :items="item.equipment_damages"/>
                    </div>
                </div>
                <div class="row">
                    <equipment-actions v-if="!this.isAddEquipmentMode" ref="actions" v-model="item.actions" />
                </div>
                <div class="row">
                    <linked-equipment
                        v-if="item.linked_equipment && item.linked_equipment.length > 0"
                        :linked-equipments="item.linked_equipment"
                    />
                </div>
            </div>

            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extStairsUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @removalConfirmed="removalConfirmed"
                @submit="handleSubmit"
            />
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {deviations, velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import {stairHelper} from "@/components/mixins/StairMixin";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import {velhoRequiredMixin} from "@/components/mixins/VelhoRequiredMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'StairEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, VelhoEditorButtons, EquipmentActions, ConditionSelector, LinkedEquipment, VelhoEquipmentLocationDetailsEditor, VelhoEquipmentDamages},
    mixins: [mapHelper, conversionModelHelper, restApi, velhoHelper, stairHelper, velhoRequiredMixin, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        updateLocationDeviation(value) {
            this.item.location_deviation = value
            if(value == deviations.AT_THE_END_OF_THE_ROAD) {
                this.item.location_specification.side = null
            }
        },
        isValidForm: function() {
            if(!this.item) {  return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateIsNumber(this.item.material)) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }

            if(this.sideRequired(this.item.location_deviation)) {
                if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
                if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }
            }

            return true
        }
    }
}
</script>

<style scoped>
</style>

